import Common from './adapter/common';
import { toast } from '../toast';
import { getMultiLang } from '../getMultiLang';
import SM from './adapter/sm';
import { syncAjax, addDataSign } from '../ajaxsync';
import { setGlobalStorage, getGlobalStorage } from '../storage';
import { getTopWindow } from '../window.js';
import { getCookie } from '../cookie';
import Symmetric from './symmetric';
import Asymmetric from './asymmetric';

const cowboyForSonar = 'cowboy';

const { loadSMJS } = SM;

const isSM = function (switchConfig = {}) {
    return (
        switchConfig.defaultSymEntryId === 'SM' ||
        switchConfig.defaultAsymEntryId === 'SM'
    );
};

/**
 * 获取配置参数（接口）
 * reload 重发
 */
const getCryptographConfig = function (reload) {
    const NCC_SYS_Switch = JSON.parse(localStorage.getItem('NCC_SYS_Switch'));

    let cipherSwitch = NCC_SYS_Switch?.secRegisterCenter;
    let pubkey = NCC_SYS_Switch?.pubkey;

    // 服务器第一次启动时，公钥还没有生成，多发几次请求来获取公钥
    if (!NCC_SYS_Switch || !cipherSwitch || reload || !pubkey) {
        let cookiets =
            (getTopWindow() && getTopWindow().cookiets) ||
            getCookie('cookiets') ||
            Date.now(); //双cookie验证 liuxis
        // 做一次 数据转型
        cookiets = isNaN(cookiets) ? cookiets : Number(cookiets);

        let reqData = {
            sysParamJson: {
                busiaction: '查询系统开关',
                pagecs: cookiets,
                ts: new Date().getTime(),
            },
        };

        let headers = {
            'Content-Type': 'application/json;charset=UTF-8',
            cookiets,
        };
        // reqData = JSON.stringify(addDataSign(reqData, '', { allin: true, headers: headers }));
        reqData = JSON.stringify(reqData);
        headers['Identifications'] = new Symmetric({ algorithmName: 'common' })?.sign('', reqData);
        syncAjax({
            type: 'post',
            url: '/nccloud/platform/total/switch.do',
            headers: headers,
            async: false,
            data: reqData,
            success: res => {
                if (res) {
                    res = JSON.parse(res);
                    if (res && res.success) {
                        if (res.data) {
                            let NCC_SYS_Switch = res.data || {};
                            // 加解密相关配置
                            pubkey = NCC_SYS_Switch?.pubkey;
                            cipherSwitch = NCC_SYS_Switch?.secRegisterCenter;

                            // 加载对应的国密js
                            if (isSM(cipherSwitch)) {
                                loadSMJS();
                            }

                            let localStorageSwitch =
                                localStorage.getItem('storeCipher');
                            //缓存是否加密开关变化了
                            if (
                                localStorageSwitch !=
                                NCC_SYS_Switch.localStorage
                            ) {
                                //localStorage加密开关与上次不一致，则清空所有localStorage内容
                                localStorage.clear();
                            }
                            localStorage.setItem(
                                'NCC_SYS_Switch',
                                JSON.stringify(NCC_SYS_Switch),
                            );
                            //开启关闭自动化测试开关
                            localStorage.setItem(
                                'storeCipher',
                                NCC_SYS_Switch.localStorage ? '1' : '0',
                            );
                            setGlobalStorage(
                                'localStorage',
                                '_ncc_automated_',
                                NCC_SYS_Switch.automated_test ? '1' : '0',
                            );
                            setGlobalStorage(
                                'localStorage',
                                '_ncc_extend_style_',
                                NCC_SYS_Switch.extendstyle ? '1' : '0',
                            );
                        }
                    } else {
                        console.log('开关加载错误', res);
                    }
                }
            },
            error(res) {
                console.log('开关加载错误', res);
            },
        });
    } else {
        // 加载对应的国密js
        if (isSM(cipherSwitch)) {
            loadSMJS();
        }
    }

    // dataSoruceEntry:yonbip"
    // defaultAsymEntryId: "yonbip"
    // defaultSymEntryId: "yonbip"

    const config = {
        ...(cipherSwitch || {}),
        pubkey,
    };

    return config;
};

/**
 * 加密解密器
 */
class Cryptograph {
    constructor(props = {}) {
        const { algorithmName, config } = props;
        if (algorithmName) {
            this.symmetricAlgorithm = new Symmetric({
                algorithmName,
                config,
            });
            this.asymmetricAlgorithm = new Asymmetric({
                algorithmName,
                config,
            });
        } else {
            const switchConfig = getCryptographConfig() || {};
            this.symmetricAlgorithmName = 'common';
            switch (switchConfig.defaultSymEntryId) {
                case 'yonbip':
                    this.symmetricAlgorithmName = 'common';
                    break;
                case 'SM':
                    this.symmetricAlgorithmName = 'sm';
                    break;
                default:
                    this.symmetricAlgorithmName = 'common';
                    break;
            }
            this.asymmetricAlgorithmName = 'common';
            switch (switchConfig.defaultAsymEntryId) {
                case 'yonbip':
                    this.asymmetricAlgorithmName = 'common';
                    break;
                case 'SM':
                    this.asymmetricAlgorithmName = 'sm';
                    break;
                default:
                    this.asymmetricAlgorithmName = 'common';
                    break;
            }

            this.symmetricAlgorithm = new Symmetric({
                algorithmName: this.symmetricAlgorithmName,
                config,
            });
            this.asymmetricAlgorithm = new Asymmetric({
                algorithmName: this.asymmetricAlgorithmName,
                config,
            });
        }
    }

    // 检查组件是否完成初始化，主要针对国密场景
    check(callback) {
        this.symmetricAlgorithm?.check(callback);
    }

    /**
     * 获取缓存的密钥
     * @returns {string}
     */
    getCacheSecretKey(params) {
        const { crux } = params;
        const switchConfig = getCryptographConfig() || {};
        const common = new Symmetric({
            algorithmName: 'common',
            config: {},
        });
        let aeskey = '';
        switch (switchConfig.defaultSymEntryId) {
            case 'SM':
                {
                    let cowboy = getGlobalStorage('localStorage', cowboyForSonar);
                    if (!cowboy) {
                        console.log('解密没有原文');
                        return '';
                    }
                    aeskey = common.symmetricDecrypt(
                        cowboy,
                        common.getStaticSecretKey(),
                    );
                }
                break;
            case 'yonbip':
            default:
                {
                    // let cruxId = String(String(crux || new Date().getTime()));
                    let cruxId = String(crux);
                    let cowboy = getGlobalStorage('localStorage', cowboyForSonar);
                    if (!cowboy) {
                        console.log('解密没有原文');
                        return '';
                    }
                    aeskey = common.symmetricDecrypt(
                        cowboy,
                        common.getStaticSecretKey(),
                    );
                    aeskey =
                        cruxId +
                        aeskey.substring(0, aeskey.length - cruxId.length);
                }
                break;
        }
        return aeskey;
    }

    /**
     * 设置缓存的密钥
     */
    setCacheSecretKey(key) {
        const common = new Symmetric({
            algorithmName: 'common',
            config: {},
        });
        if (!key) {
            console.log('加密没有原文');
            return '';
        }
        let cowboy =
            getGlobalStorage('localStorage', cowboyForSonar) ||
            common.symmetricEncrypt(key, common.getStaticSecretKey());
        // 如果浏览器器中出现了两个用户  以第一个用户的为主  保持同一个浏览器中唯一
        setGlobalStorage('localStorage', cowboyForSonar, cowboy); // 当前的
    }

    /**
     * 静态对称密钥，用于处理某些全局无法通信的加密
     * @returns {string}
     */
    getStaticSecretKey() {
        return this.symmetricAlgorithm?.getStaticSecretKey();
    }

    /**
     * 对称加密
     * @param {string} message
     * @param {string} key
     * @returns  {string}
     */
    symmetricEncrypt(message = '', key) {
        return this.symmetricAlgorithm?.symmetricEncrypt(message, key);
    }

    /**
     * 对称解密
     * @param {string} message
     * @param {string} key
     * @returns  {string}
     */
    symmetricDecrypt(message = '', key) {
        return this.symmetricAlgorithm?.symmetricDecrypt(message, key);
    }

    /**
     * 生成密钥
     * @returns {string}
     */
    generateSecretKey() {
        return this.symmetricAlgorithm?.generateSecretKey();
    }

    /**
     * 获取存储的密钥
     * @returns {string}
     */
    getSecretKey() {
        return this.symmetricAlgorithm?.getSecretKey();
    }

    // 加签
    sign(salt, data) {
        return this.symmetricAlgorithm?.sign(salt, data);
    }

    /**
     * 非对称加密
     * @param {string} message
     * @param {string} key
     * @returns {string}
     */
    asymmetricEncrypt(message, key) {
        return this.asymmetricAlgorithm?.asymmetricEncrypt(message, key);
    }

    /**
     * 非对称解密
     * @param {string} message
     * @param {string} key
     * @returns {string}
     */
    asymmetricDecrypt(message, key) {
        return this.asymmetricAlgorithm?.asymmetricDecrypt(message, key);
    }

    /**
     * 获取公钥
     * @returns {string}
     */
    generatePublicKey() {
        return this.asymmetricAlgorithm?.generatePublicKey();
    }

    // 发送ajax 获取后端的公钥
    getAsyncPublicKey() {
        const switchConfig = getCryptographConfig() || {};
        const pubkey = switchConfig.pubkey;
        let result = '';

        switch (switchConfig.defaultAsymEntryId) {
            case 'yonbip':
                result = this.asymmetricAlgorithm?.getPublicKey(pubkey);
                break;
            case 'SM':
                result = JSON.stringify(pubkey || '');
                break;
            default:
                result = this.asymmetricAlgorithm?.getPublicKey(pubkey);
                break;
        }

        if (!result) {
            console.error('未找到公钥');
            let getJsonCallback = json => {
                toast({
                    color: 'danger',
                    title: json['api-app-pageTo-0001'],
                    content: json['api-app-pageTo-0002'],
                });
            };
            getMultiLang({
                moduleId: 'api_cryptograph',
                callback: getJsonCallback,
            });
        }

        return result;
    }
}

Cryptograph.SM = SM;
Cryptograph.Common = Common;
Cryptograph.getCryptographConfig = getCryptographConfig;

export default Cryptograph;
